import { Box } from '@eatclubapp/ec-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './CardStyles';

/**
 * A container for a bunch of data usually representing an item in a list or grid
 */
const Card = ({
  children,
  className,
  disabled, // Prevent the card from being interacted with (if it has an onclick)
  onClick, // Make the card interactive
  active, // Whether it's currently selected
  style,
  ...rest
}) => {
  const isInteractive = onClick !== null;
  const classes = useStyles({ style, active, isInteractive });

  return (
    <Box
      className={`${classes.wrapper} ${className} ${active && !disabled ? classes.active : ''} ${
        disabled ? classes.disabled : ''
      }`}
      disabled={disabled}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Box>
  );
};

Card.defaultProps = {
  active: false,
  disabled: false,
  onClick: null,
  children: null,
  className: '',
  style: {},
};

Card.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.shape({}),
};

export default Card;
